<template>
  <div
    id="komstore-onboarding-container"
    class="h-screen bg-white"
  >
    <iframe
      frameborder="1"
      height="100%"
      width="100%"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/online-store/onboarding`"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
    }
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
    document.body.classList.add('hide-footer')
  },
  beforeDestroy() {
    window.removeEventListener('message', this.watchIframe)
    document.body.classList.remove('hide-footer')
  },
  methods: {
    watchIframe(event) {
      if (event.data === 'success_onboarding_komstore') {
        const userData = JSON.parse(localStorage.getItem('userData'))
        userData.is_onboarding_komstore = 1
        localStorage.setItem('userData', JSON.stringify(userData))
        this.$router.push({ name: 'dashboard-analytics' })
      }
    },
  },
}
</script>

<style>
body.hide-footer .footer {
  display: none !important;
}
</style>
